var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinterest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.987 0C7.157 0 0 7.158 0 15.987c0 6.776 4.21 12.566 10.158 14.895-.145-1.264-.263-3.21.053-4.593.289-1.25 1.868-7.947 1.868-7.947s-.474-.96-.474-2.368c0-2.224 1.29-3.882 2.895-3.882 1.368 0 2.026 1.026 2.026 2.25 0 1.368-.868 3.421-1.329 5.33-.381 1.591.803 2.894 2.369 2.894 2.842 0 5.026-3 5.026-7.316 0-3.829-2.75-6.5-6.684-6.5-4.553 0-7.224 3.408-7.224 6.934 0 1.369.527 2.842 1.184 3.645a.476.476 0 01.106.46c-.119.5-.395 1.593-.448 1.816-.065.29-.237.355-.54.21-2-.933-3.25-3.841-3.25-6.197 0-5.04 3.659-9.67 10.567-9.67 5.54 0 9.855 3.947 9.855 9.236 0 5.513-3.474 9.948-8.29 9.948-1.618 0-3.144-.843-3.657-1.843l-1 3.803c-.356 1.395-1.33 3.132-1.987 4.198 1.5.46 3.079.71 4.736.71 8.83 0 15.987-7.158 15.987-15.987C31.974 7.158 24.816 0 15.987 0z",
    fill: "#E60023"
  })));
}
export default SvgPinterest;